import UKDialog from "@/components/UKDialog";
import { DialogContent, DialogTitle } from "@mui/material";
import styles from './deliveryDialog.module.scss'
import { useTranslation } from "@/i18n/client";
import CDNImage from '@/components/cdnImage/cdnImage'

export default function ChooseDelivery(props: any) {
  const {
    openDialog,
    setOpenDialog,
    mainTitle,
    fulfillmentMethodList,
    shipmentType,
    handleSelectedDelivery,
    openCheckout
  } = props

  const { t } = useTranslation();


  return (
    <UKDialog
      open={openDialog}
      onClose={() => { setOpenDialog(false) }}
      showCloseBtn={true}
      sx={{
        "& .MuiDialog-paper": {
          width: "480px",
        },
      }}
    >
      <DialogTitle>{mainTitle}</DialogTitle>
      <DialogContent>
        <div className={styles.choose_wrap}>
          {
            fulfillmentMethodList.map((item: any) => {
              return (
                <div
                  className={`${styles.choose_option} ${shipmentType === item.shipmentType ? styles.active : ''}`}
                  onClick={() => handleSelectedDelivery(item.shipmentType)}
                  key={item.shipmentType}
                >
                  <div className={styles.choose_item}>
                    <CDNImage
                      className={styles.choose_icon}
                      src={item.icon}
                      width={32}
                      height={32}
                      alt={item.title}
                    />
                    <div className={styles.choose_text}>{item.title}</div>
                    <div className={styles.choose_content} dangerouslySetInnerHTML={{ __html: item.deliveryTime }}></div>
                  </div>
                  <div className={styles.choose_price} dangerouslySetInnerHTML={{ __html: item.price }}></div>
                </div>
              )
            })
          }
        </div>
        <div className={styles.choose_btn_wrap}>
          <div
            className={styles.choose_btn}
            onClick={openCheckout}
          >
            {t('dp.buyNow')}
          </div>
        </div>
      </DialogContent>

    </UKDialog>
  )
}
